// extracted by mini-css-extract-plugin
module.exports = {"sliderParent":"Slider_sliderParent__3K7BW","sliderContainer":"Slider_sliderContainer__3F7_8"};